import { isBicentenary, isZsl } from '@/lib/utils';
import { buttonPrimary, colors, GridWrapper, mediaQueries } from '@/theme/lib';
import styled, { css } from 'styled-components';

export const StyledGeneralListing = styled(GridWrapper).withConfig({
  shouldForwardProp: (prop) => prop !== 'alignment',
})<{alignment: string}>`
.general-listing {
  &__intro {
    margin-bottom: 1.5rem;
    margin-top: 1.5rem;
    ${mediaQueries.md} {
      display: grid;
      grid-template-columns: repeat(8, [col-start] 1fr);
      gap: 2rem;
      width: 100%;
      flex-flow: row nowrap;
      justify-content: space-between;
    }
    ${mediaQueries.lg} {
      margin-bottom: 2rem;
    }
    &-text {
      ${mediaQueries.md} {
        grid-column: 1 / span 5;
      }
    }
  }
  &__title {
    color: ${(props) => props.theme.colors.heading};
    ${(props) => isBicentenary(props.theme.key) ? css`
        color: ${(props) => colors.butterfly};
        font-weight: 800;
        font-family: ${(props) => props.theme.fonts.h1};
      ` : ''}
    line-height: 110%;
    margin-bottom: 0.75rem;
    font-weight: 600;
    ${mediaQueries.md} {
      margin-bottom: 1rem;
    }
  }
  &__description div {
    color: ${(props) => props.theme.colors.heading};
    line-height: 140%;
    ${mediaQueries.lg} {
      font-size: 1.125rem;
      line-height: 145%;
    }
  }
  &__cards-list {
    padding-bottom: 1rem;
    margin-bottom: 1.125rem;
    border-bottom: ${props => props.theme.key === 'bicentenary' ? `1px solid ${colors.seagrass}` : `1px solid ${colors.honeyBee}`};
    list-style: none;

    li {
      margin-bottom: 1.5rem;

      &:last-of-type {
        margin-bottom: 0;
      }
      ${mediaQueries.xl} {
        margin-bottom: 2rem;
      }
    }

    ${mediaQueries.md} {
      border: none;
      margin-bottom: 0;
      display: inline-grid;
      width: 100%;
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 1rem;
      ${mediaQueries.lg} {
        grid-column-gap: 2rem;
      }
      ${mediaQueries.xl} {
        grid-column-gap: 2.25rem;
      }
    }
    .generic-card {
      margin-bottom: 1.5rem;
      max-width: 590px;
      &:last-of-type {
        margin-bottom: 0;
      }
      ${mediaQueries.xl} {
        margin-bottom: 2rem;
      }
      &__img-wrapper {
        height: auto;
        aspect-ratio: 590/355;
        > a {
         > span {
          height: 100% !important;
          width: 100% !important;
         }
        }
      }
      &__text {
        height: auto;
      }
    }
  }
}
.btn-primary {
  ${buttonPrimary}
  font-weight: ${(props) => isZsl(props.theme.key) ? '400' : '700'};
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  align-self: flex-end;
  border-radius: ${(props) => isZsl(props.theme.key) ? props.theme.config.buttonRadius : '12px'};
  ${mediaQueries.lg} {
   border-radius: ${(props) => isZsl(props.theme.key) ? props.theme.config.buttonRadius : '16px'};
  }

  ${(props) =>
    isBicentenary(props.theme.key) ? css`
      background-color: ${colors.seagrass};
      color: ${colors.white};
      &:hover {
        background: ${colors.white};
        border-color: ${colors.gecko78};
        color: ${colors.panther};
      }
    ` : ''}


  &--desktop {
    margin-top: 0;
    display: none;
    ${mediaQueries.md} {
      grid-column: 7 / span 2;
      display: inline-flex;
      padding: 1.125rem 1.75rem 1rem;
    }
  }
  &--mobile {
    ${mediaQueries.md} {
      display: none;
    }
  }
}
${mediaQueries.lg} {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}
.generic-card__text--eyebrow {
  ${props => isBicentenary(props.theme.key) ? css`
    color: ${colors.black}
  ` : ''}
}
`;
